import { useMutation, useQueryClient } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';

const deleteCustomField = async (customFieldId: string): Promise<void> => {
  await customAxios.delete(`/custom-fields/${customFieldId}`);
};

export const useDeleteCustomField = (orgId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteCustomField,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['custom-fields', orgId] }).catch(() => undefined);
    },
  });
};
